import React     from 'react'
import PropTypes from 'prop-types'

import ActionButton        from '../components/ActionButton'
import NewMaintenanceModal from './NewMaintenanceModal'


export default class NewMaintenanceTemplateButton extends React.Component {
  static propTypes = {
    history:             PropTypes.object.isRequired,
    maintenanceTemplate: PropTypes.object.isRequired,
  }

  state = {
    modalOpen: false,
  }

  handleNew = () => {
    return Promise.resolve({})
  }

  handleNewComplete = () => {
    this.setState({ modalOpen: true })
  }

  handleCloseModal = () => {
    this.setState({ modalOpen: false })
  }
  
  render() {
    const { maintenanceTemplate, history } = this.props
    const { modalOpen } = this.state

    return (
      <React.Fragment>
        <ActionButton
          buttonIconName="power off"
          buttonText="New Maintenance Mode"
          onPerformAction={this.handleNew}
          onPerformActionComplete={this.handleNewComplete}
        />

        <NewMaintenanceModal
          open={modalOpen}
          history={history}
          onClose={this.handleCloseModal}
          maintenanceTemplate={maintenanceTemplate}
        />
      </React.Fragment>
    )
  }
}
